<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import { useStore } from "@/store/store.js"

export default {
  name: "FilooApp",

  setup () {
    const store = useStore()

    return {
      setWindowWidth: (size) => store.dispatch("updateWindowWidth", size),
    }
  },

  async mounted() {
    this.toggleClassInBody(themeConfig.theme)

    this.$nextTick(() => {
      window.addEventListener("resize", this.handleWindowResize)
    })

    await this.handleWindowResize()
     
    this.hideJiraButtonAccordingToCurrentRoute()
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize)
  },

  methods: {
    toggleClassInBody (theme) {
      const classes = ['theme-dark', 'theme-semi-dark']
      const { classList, className } = document.body
      
      classes.forEach((cls) => (
        className.match(cls) && classList.remove(cls)
      ))

      if (theme === 'dark') {
        classList.add('theme-dark')
      }
      
      if (theme === 'semi-dark') {
        classList.add('theme-semi-dark')
      }
    },

    async handleWindowResize() {
      await this.setWindowWidth(document.documentElement.clientWidth)
    },

    hideJiraButtonAccordingToCurrentRoute () {
      if(this.$route.name !== "/suporte_interno") {
        document.getElementById("jsd-widget").style.display = "gone"
      }
    }
  },

  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val);
    }
  }
}

</script>
